import { useEffect, useState } from "react";
import { updateUserIsAdminById } from "wasp/client/operations";
import { Switch } from "../../../components/ui";

interface IsAdminToggleProps {
  userId: string;
  isAdmin: boolean;
  disabled?: boolean;
}

export function IsAdminToggle({
  userId,
  isAdmin,
  disabled = false,
}: IsAdminToggleProps) {
  const [checked, setChecked] = useState(isAdmin);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setChecked(isAdmin);
  }, [isAdmin]);

  const handleCheckedChange = async (nextChecked: boolean) => {
    if (isUpdating) {
      return;
    }

    const previousChecked = checked;
    setChecked(nextChecked);
    setIsUpdating(true);

    try {
      await updateUserIsAdminById({ id: userId, isAdmin: nextChecked });
    } catch {
      setChecked(previousChecked);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Switch
      checked={checked}
      onCheckedChange={handleCheckedChange}
      disabled={disabled || isUpdating}
      tone="primary"
      aria-label={checked ? "Revoke admin access" : "Grant admin access"}
    />
  );
}
